import {
  IconButton,
  Badge,
  Typography,
  MenuItem,
  CardContent,
  Card,
  Box,
  CircularProgress,
} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import React, { useEffect } from 'react';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import clsx from 'clsx';
import useStyles from '../styles';
import { requiredLogin } from '../../../../middlewares';
import FormattedMenu from 'components/atoms/FormattedMenu';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import Avatar from 'components/atoms/Avatar';
import Skeleton from '@material-ui/lab/Skeleton';
import CommonActions from 'redux/reducers/gl_common_reducer/actions';
import {
  Customer_NotificationsListElement,
  useGetCustomer_NotificationsList,
} from 'redux/reducers/gl_common_reducer/selectors';
import { Environment } from 'config';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { StateStatus } from 'redux/utils/common';
import { LanguagesEnum } from 'constants/languages';
import * as LanguageSelectors from 'redux/reducers/gl_translations_reducer/selectors';
import { fromNowWithLanguage } from 'utils/dates';

const menuId = 'navNotification';

function truncate(str: string, n: number) {
  const truncated = str && str.length > n ? str.slice(0, n - 1) + '...' : str;
  return truncated;
}

const NotificationButton = () => {
  const classes = useStyles({});
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [currentPageSize, setcurrentPageSize] = React.useState<number>(5);
  const languageID: LanguagesEnum = LanguageSelectors.useSelectLanguageID();

  const isMenuOpen = Boolean(anchorEl);
  const dispatch = useDispatch();
  const customerNotification = useGetCustomer_NotificationsList();
  const numItems = customerNotification.data?.items.length || 0;

  const totalItems = customerNotification.data?.paging.total || 0;

  // const history = useHistory();
  useEffect(() => {
    dispatch(
      CommonActions.fetchCustomer_NotificationsListAction({
        page: 0,
        pageSize: currentPageSize,
        order: 'desc',
        sortField: 'datesend',
      })
    );
  }, []);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const renderProfileMenu = (
    <FormattedMenu
      classes={{ list: classes.notificationList }}
      anchorEl={anchorEl}
      id={menuId}
      keepMounted
      elevation={1}
      open={isMenuOpen}
      onClose={handleMenuClose}
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      {customerNotification.data?.items?.map(
        (item: Customer_NotificationsListElement) => {
          return (
            <MenuItem
              key={item.id}
              style={{
                padding: '10px',
              }}
              // style={{ marginLeft: props.submenu ? 5 : 0 }}
              // key={index}
              onClick={() => {
                window.open(item.url, '_blank')?.focus();
                handleMenuClose();
                dispatch(
                  CommonActions.editCustomer_NotificationsAction({
                    ...item,
                    viewed: 1,
                    fetchCustomer_NotificationsInput: {
                      page: 0,
                      pageSize: currentPageSize,
                      order: 'desc',
                      sortField: 'datesend',
                    },
                  })
                );
              }}
            >
              {/* {props.icon && (
              <ListItemIcon color="inherit">{props.icon}</ListItemIcon>
            )} */}
              <Box width="360px" display="flex" alignItems="center">
                <Box width="20%" marginRight="10px">
                  <Avatar
                    name={item.emailrecepient}
                    image={`${Environment.API_BASE_URL}/${item.avatar}`}
                    className={classes.notificationAvatar}
                  />
                </Box>
                <Box width="80%">
                  <Box>
                    <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                      {truncate(item.subject, 35)}
                    </Typography>
                    <Typography
                      className={classes.notificationContent}
                      align="left"
                      variant="body1"
                    >
                      {truncate(item.url, 30)}
                    </Typography>
                    <Typography variant="body1" style={{ color: '#0047e9' }}>
                      {fromNowWithLanguage(new Date(item.datesend), languageID)}
                    </Typography>
                  </Box>
                </Box>
                {/* <Box width="10%">
                  <FiberManualRecordIcon
                    style={{ height: 16, width: 16, color: '#0047e9' }}
                  />
                </Box> */}
              </Box>
            </MenuItem>
          );
        }
      )}
      {customerNotification.status === StateStatus.Pending && (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}
      {numItems < totalItems && (
        <Box display="flex" justifyContent="center">
          <Typography
            onClick={() => {
              const newPageSize = currentPageSize + 5;
              dispatch(
                CommonActions.fetchCustomer_NotificationsListAction({
                  page: 0,
                  pageSize: newPageSize,
                  order: 'desc',
                  sortField: 'datesend',
                })
              );
              setcurrentPageSize(newPageSize);
            }}
            style={{ color: '#0047e9', cursor: 'pointer' }}
          >
            <TranslatedTextV2
              defaultText="View more"
              translationKey="notification.view_more"
            />
          </Typography>
        </Box>
      )}
    </FormattedMenu>
  );

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div
      className={classes.navbarElementSpacing}
      style={{ display: 'flex', alignItems: 'center', margin: 'auto' }}
    >
      <IconButton
        onClick={handleProfileMenuOpen}
        color="inherit"
        className={clsx(classes.navbarElementSpacing)}
      >
        <Badge
          badgeContent={customerNotification.data?.paging.total || 0}
          color="error"
        >
          <NotificationsNoneOutlinedIcon />
        </Badge>
      </IconButton>
      {renderProfileMenu}
    </div>
  );
};

export default requiredLogin(NotificationButton);
